import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [resetCode, setResetCode] = useState('');
  
  const navigate = useNavigate();
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setResetCode('');

    if (!email) {
      setError('Введите email');
      return;
    }

    setLoading(true);
    try {
      const result = await forgotPassword(email);
      
      if (result.success) {
        setSuccess(true);
        
        // Если код пришел в ответе (режим разработки)
        if (result.resetCode) {
          setResetCode(result.resetCode);
        }
        
        // Редирект на страницу сброса пароля через 2 секунды
        setTimeout(() => {
          const params = new URLSearchParams();
          params.append('email', email);
          if (result.resetCode) {
            params.append('code', result.resetCode);
          }
          navigate(`/reset-password?${params.toString()}`);
        }, 2000);
      } else {
        setError(result.message || 'Ошибка при отправке кода');
      }
    } catch (err) {
      setError(err.message || 'Ошибка при отправке кода');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <h1>Восстановление пароля</h1>
        
        {success ? (
          <div className="success-message">
            <p>✅ Код сброса пароля отправлен на {email}</p>
            {resetCode && (
              <div className="dev-code-notice">
                <strong>Режим разработки:</strong> Код был автоматически заполнен из ответа сервера
              </div>
            )}
            <p>Перенаправляем на страницу сброса пароля...</p>
          </div>
        ) : (
          <>
            <p className="forgot-password-info">
              Введите ваш email, и мы отправим код для сброса пароля
            </p>

            <form onSubmit={handleSubmit} className="forgot-password-form">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className={error ? 'error' : ''}
                  disabled={loading}
                  required
                  autoFocus
                />
              </div>

              {error && <div className="error-message">{error}</div>}

              <button 
                type="submit" 
                className="btn-primary"
                disabled={loading || !email}
              >
                {loading ? 'Отправка...' : 'Отправить код'}
              </button>
            </form>

            <div className="back-to-login">
              <Link to="/login">Вернуться к входу</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
